import { GridColumnGroup } from '@mui/x-data-grid-pro';

interface GridColumnGroupFactoryOptions {
  tGroup: (key: string, options?: Record<string, any>) => string;
}

export const gridColumnGroupFactory =
  ({ tGroup }: GridColumnGroupFactoryOptions) =>
  (columnGroup: GridColumnGroup): GridColumnGroup => ({
    freeReordering: true,
    headerName: tGroup(columnGroup.groupId),
    ...columnGroup,
  });
